<template>
  <router-view />
</template>

<script>
export default {
  name: 'BulletinsIndex'
}
</script>
